<template>
    <div
        :class="[
            $style['cool-input'],
            $style['cool-input-' + theme],
            numberArrows === false ? $style['no-arrows'] : '',
        ]"
    >
        <slot></slot>
    </div>
</template>

<style module>
.cool-input-default > input,
.cool-input-default > textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 6px;
    border-radius: 4px;
    border: 1px solid #ccc;
    color: #000;
}

.cool-input-checkout > input,
.cool-input-checkout > textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 6px;
    border-radius: 2px;
    border: 2px solid #dddddd;
    background-color: #ffffff;
    color: #272727;
    min-height: 42px;
}

/* Chrome, Safari, Edge, Opera */
.cool-input.no-arrows > input[type="number"]::-webkit-outer-spin-button,
.cool-input.no-arrows > input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
.cool-input.no-arrows > input[type="number"] {
    -moz-appearance: textfield;
}
</style>

<script>
export default {
    props: {
        numberArrows: {
            type: Boolean,
            default: true,
        },
        theme: {
            default: "default",
            type: String,
        },
    },
};
</script>
